"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sections = exports.DynamicSection = exports.StaticSection = exports.sectionReader = void 0;
const tslib_1 = require("tslib");
const t = (0, tslib_1.__importStar)(require("io-ts"));
const common_1 = require("../common");
const Widget_1 = require("./widgets/Widget");
function sectionReader(codec) {
    return t.record(common_1.WidgetKey, codec); // WidgetId -> Widget Data
}
exports.sectionReader = sectionReader;
exports.StaticSection = sectionReader(Widget_1.StaticWidget);
exports.DynamicSection = sectionReader(Widget_1.DynamicWidget);
exports.Sections = {
    toStatic(dynamic, sharedSlices) {
        const section = Object.entries(dynamic).reduce((acc, [widgetKey, widget]) => {
            return { ...acc, [widgetKey]: Widget_1.Widgets.toStatic(widget, sharedSlices) };
        }, {});
        return section;
    },
};
